<template>
  <div class="home">
    <div class="banner">
      <swiper :options="swiperOption" class="swiper">
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <img :src="item.img" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <!-- banner文字 -->
      <div class="banner_content">
        <div>
          <h2>{{banner_title.name}}</h2>
          <ul>
            <li>{{banner_title.top_title}}</li>
            <!-- <li>服务</li>
            <li>发展</li>
            <li>创新</li> -->
          </ul>
        </div>
        <p class="content">{{banner_title.next_title}}
        </p>
        <div class="more_btn" @click="LinkTo($event,'/brief')">了解更多</div>
      </div>
    </div>

    <div class="introduc">
      <!-- 公司简介 -->
      <div class="business">
        <div class="titleImg">
          <img src="../static/img/home/biaoti_1.png" alt />
        </div>
        <div class="flex-center">
          <div class="W1200 business_content flex-between">
            <div class="b_left">
              <div class="aboutUs flex-column-between">
                <div class="usTitle">{{introduction.top_title}}</div>
                <div class="usName">{{introduction.next_title}}</div>
              </div>
              <div class="aboutContent">
                <p>
                  四川华顺源建设工程有限公司（简称四川华顺源）成立于2018年，是经建设厅核准的具有输变电工程专业承包三级资质；电力工程施工总承包三级；城市及道路照明工程专业承包三级；市政公用工程施工总承包三级资质。
                  公司长期从事电力设备及配件研发、设计、销售；电源设备研发、租赁及技术服务；新能源技术开发、技术咨询等行业。从组建至今不断举办各类施工、智能技术培训，实行外招、内培方法，不断注入新鲜血液，使公司不断发展壮大。为了适应形势的发展，提高技术含量，目前公司现有职工112余名，注册一级建造师2人、二级建造师10人；各类高、中级工程管理人员和工程技术人员22人以及其他各类人员78人。
                </p>
              </div>
              <div class="more_btn1" @click="LinkTo($event,'/brief')">
                <p>了解更多</p>
                <img class="more_btn1_img" src="../static/img/home/right.png" alt />
              </div>
              <div class="statisticalNum">
                <ul class="flex-between">
                  <li v-for="(item,index) in aboutus" :key="index" class="statItem flex-column-center">
                    <div class="flex-center">
                      <div class="statItemNum">{{item.num}}</div>
                      <div class="statItemUnit">{{item.unit}}</div>
                    </div>
                    <div class="statItemCon">{{item.content}}</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="b_right">
              <img :src="introduction.img" alt />
            </div>
          </div>
        </div>
      </div>

      <!-- 业务范围 -->
      <div class="business mb40">
        <div class="titleImg">
          <img src="../static/img/home/biaoti_2.png" alt />
        </div>
        <div class="flex-center">
          <div class="W1200 flex-between">
            <div v-for="(item,index) in rangeList" :key="index" class="range_item"
              :style="{backgroundImage:'url('+ item.url+')'}">
              <div class="name">
                {{item.title}}
              </div>
              <div class="hover_item flex">
                <div >
                  <div class="hover_item_logo"><img :src="item.logo" alt=""></div>
                <div class="hover_item_title">{{item.title}}</div>
                <div class="flex"><div class="hover_item_line"></div></div>
                <div class="flex"><div class="hover_item_content">{{item.content}}</div></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- 新闻中心 -->
      <div class="business">
        <div class="titleImg">
          <img src="../static/img/home/biaoti_3.png" alt />
        </div>
        <div class="flex-center">
          <div class="W1200 news_content flex-between">
            <!-- 左侧 -->
            <div class="news_left" >
<!--              v-for="(item,index) in news_neer" :key="index"-->
              <div style="height:370px;overflow: hidden;">
                <img :src="news_neer.news_headpic" />
              </div>
              <div class="news_left_content">
                <div class="news_left_content_title">[{{news_neer.news_title}}]</div>
                <div class="news_left_content_date">{{news_neer.create_time}}</div>
                <div class="news_left_content_brief over3">
                  {{news_neer.news_brief}}
                </div>
              </div>
<!--              <div class="know_more" @click="LinkTo($event,'/newscenter')">了解更多 ></div>-->
            </div>
            <!-- 右侧 -->
            <div class="news_right">
              <div class="news_right_top flex-column-between">
                <div class="new_right_title ml10">NEWS</div>
                <div class="new_right_bottom flex-start-end ml10">
                  <div class="new_right_name">公司新闻</div>
                  <img src="../static/img/home/line.png" class="ml10" alt />
                </div>
              </div>
              <div class="news_right_content_cc">
                <div class="news_right_content" v-for="(item,index) in news" :key="index" @mouseover="newtile(index)">
                  <div class="news_right_content_title flex-between mr20 ml53">
                    <h3>[ {{item.news_title}} ]</h3>
                    <p>{{item.create_time}}</p>
                  </div>
                  <p class="ml53 mr20 content" >{{item.news_brief}}</p>
                  <div class="news_right_content_line ml53"></div>
                </div>
              </div>
              <div class="know_more" @click="LinkTo($event,'/newscenter')">了解更多 ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import {getHomeInfo} from '../api/apis.js'
  export default {
    name: "home",
    data() {
      return {
        swiperList: [{
            url: require("../static/img/home/banner.png")
          },
          {
            url: require("../static/img/home/banner.png")
          }
        ],
        swiperList1: [{
            url: require("../static/img/home/tu.png")
          },
          {
            url: require("../static/img/home/tu.png")
          }
        ],
        swiperOption: {
          loop: true, // 循环模式选项
          autoplay: {
            delay: 5000
          },
          pagination: {
            el: ".swiper-pagination"
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        aboutus: [{
            num: '',
            unit: "+ 年",
            content: "企业历史"
          },
          {
            num: '',
            unit: "+ 人",
            content: "技术人才"
          },
          {
            num: '',
            unit: "+ 家",
            content: "服务企业"
          },
          {
            num: '',
            unit: "+ 个",
            content: "成功案例"
          }
        ],
        rangeList: [{
            logo: require('../static/img/home/login1.png'),
            url: require('../static/img/home/gongren.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "施工"
          },
          {
            logo: require('../static/img/home/login2.png'),
            url: require('../static/img/home/shizheng.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "市政工程"
          },
          {
            logo: require('../static/img/home/login3.png'),
            url: require('../static/img/home/chengshi.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "城市及道路照明工程"
          }
        ],
        introduction:{},
        business:{},
        news:[],
        banner_title:{},
        banner:[],
        news_banner:[],
        news_neer:[]
      };
    },
    // mounted(){
    //   console.log(this.news,'iiiiiiii')
    //   this.news_neer = this.news[0]
    // },
    methods: {
      LinkTo(e,path){
        this.$router.push({path:path})
      },
      newtile(index){
          console.log(this.news[index],'index')
        this.news_neer = this.news[index]
      },
      //获取首页展示信息
      initHome(){
        getHomeInfo().then(res => {
          this.banner_title = res.banner_title;
          this.banner = res.banner;
          this.news_banner = res.news_banner;
          this.introduction = res.introduction;
          this.business = res.business;
          this.news = res.news;
          this.news_neer = res.news[0];
          console.log(this.news_neer,'ddddddd')
          // this.$set(aboutus[0],'num',res.introduction.history);
          // this.$set(aboutus[1],'num',res.introduction.personnel);
          // this.$set(aboutus[2],'num',res.introduction.service);
          // this.$set(aboutus[3],'num',res.introduction.case);

          this.aboutus[0].num = res.introduction.history;
          this.aboutus[1].num = res.introduction.personnel;
          this.aboutus[2].num = res.introduction.service;
          this.aboutus[3].num = res.introduction.case;
          this.initBuiness(res.business);
          

        })
      },
      //转换business类容
      initBuiness(list){
        let newList = this.rangeList;
        list.forEach((item,index) => {
          newList[index].url = item.img;
          newList[index].title = item.title;
          newList[index].content = item.content;
        });
      }
    },
    created() {
      this.initHome();
    },
  };
</script>
<style scoped lang='scss'>
  .banner {
    position: relative;
  }

  .swiper {
    width: 100%;
    
  }

  .swiper img {
    width: 100%;
    /* height: 370px; */
  }

  .banner_content {
    z-index: 2;
    width: 1029px;
    position: absolute;
    top: 126px;
    left: 50%;
    margin-left: -510px;

    right: 364px;
    color: #ffffff;

    h2 {
      font-size: 92px;
    }

    ul {
      margin: 31px 0px 31px 0px;
    }

    li {
      display: inline-block;
      font-size: 48px;
      margin-right: 24px;
    }

    .content {
      width: 727px;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 41px;
    }
  }

  .more_btn {
    border: 2px solid rgba(246, 246, 246, 1);
    border-radius: 33px;
    padding: 23px 63px 23px 63px;
    font-size: 20px;
    display: inline-block;
    cursor: pointer;
  }

  .more_btn1 {
    padding: 12px 26px;
    width: 130px;
    background-color: #1b5ba0;
    display: flex;
    cursor: pointer;
    p {
      font-size: 14px;
      color: #ffffff;
    }

    img {
      width: 16px;
      height: 16px;
      margin-left: 30px;
    }
  }

  .titleImg {
    text-align: center;

    img {
      width: 576px;
      height: 152px;
      margin: 49px;
    }
  }

  .introduc {
    width: 100%;
    background-image: url("../static/img/home/bgimg.png");
  }

  .W1200 {
    width: 1200px;
  }

  .business_content {
    .b_left {
      width: 560px;
      height: 680px;
    }

    .b_right {
      width: 600px;
      height: 680px;
    }
  }

  .aboutUs {
    height: 88px;
    border-left: 8px solid #1b5ba0;
    text-align: left !important;

    .usTitle {
      text-transform: uppercase;
      padding-left: 34px;
      font-size: 48px;
      color: #1b5ba0;
    }

    .usName {
      padding-left: 34px;
      font-size: 24px;
      color: #999999;
    }
  }

  .aboutContent p {
    margin-top: 56px;
    margin-bottom: 36px;
    color: #333333;
    line-height: 26px;
    font-size: 16px;
    height: 250px;
    overflow: hidden;
  }

  .statisticalNum li {
    width: 150px;
    height: 156px;
    color: #1b5ba0;
    margin-top: 54px;
  }

  .statisticalNum li:hover {
    background-color: #F1F5F8;
    color: #E20000;

    .statItemCon {
      color: #666666 !important
    }
  }

  .statItem {
    .statItemNum {
      font-size: 40px;
      font-weight: bold;
    }

    .statItemUnit {
      font-size: 16px;
      width: 16px !important;
      text-align: center;
      line-height: 25px;
      font-weight: bold;
    }

    .statItemCon {
      font-size: 20px;
      margin-top: 20px;
    }
  }

  /* 业务范围 */
  .range_item {
    width: 360px;
    height: 384px;
    position: relative;

    .name {
      font-size: 24px;
      height: 46px;
      width: 100%;
      position: absolute;
      bottom: 0px;
      text-align: center;
      line-height: 46px;
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.4);
      display: block;
    }

    .hover_item {
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.4);
      display: none;
      color: #ffffff;

      .hover_item_logo {
        width: 100%;
        /* margin-top:30px; */
        img{
          width: 66px;
        height: 68px;
          margin-top:30px;
        }
      }

      .hover_item_title {
        margin-top: 40px;
        font-size: 24px;
      }

      .hover_item_line {
        margin-top: 15px;
        width: 70px;
        height: 2px;
        background-color: #ffffff;
      }
      .hover_item_content{
        margin-top: 30px;
        width:279px;
        height: 140px;
       font-size:14px;
       line-height: 28px;
       overflow: hidden;
      }
    }
  }

  .range_item::before,
  .range_item::after {
    content: '';
    position: absolute;
    width: 284px;
    height: 17px;
    background-color: #F1F5F8;
    left: 39px;

  }

  .range_item::before {
    top: -17px;
  }

  .range_item::after {
    bottom: -17px;
  }

  .range_item:hover {
    .name {
      display: none;
    }

    .hover_item {
      display: block;
    }

  }

  .range_item:hover::after,
  .range_item:hover::before {
    background-color: #1584F5;
  }

  .news_left,
  .news_right {
    width: 600px;
    height: 568px;
    overflow: hidden;
    position: relative;
  }

  .news_right_top {
    height: 46px;
    border-left: 2px solid #1b5ba0;
    margin: 57px 0px 33px 53px;

    .new_right_title {
      color: #1b5ba0;
      font-size: 18px;
    }

    .new_right_bottom {
      .new_right_name {
        font-size: 24px;
        color: #333333;
      }

      img {
        width: 316px;
      }
    }
  }

  .news_content {
    margin-bottom: 284px;

    .news_left {}

    .news_right {
      background-color: #f1f5f8;
    }
  }

  .news_right_content_cc div:hover {
    background: #1584F5;

    h3 {
      color: #ffffff !important;
    }

    p {
      color: #ffffff !important;
    }

    color: #ffffff !important;
  }

  .news_right_content {
    height: 120px;
    overflow: hidden;
    .news_right_content_title {
      line-height: 50px;

      h3 {
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        margin-top: 15px;
      }

      p {
        /*width: 100%;*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }

    .content {
      color: #666666;
      line-height: 26px;
    }

    .news_right_content_line {
      width: 550px;
      height: 1px;
      margin-left: 50px;
      background-color: #bfbfbf;
      margin-top: 10px;
      opacity: 0.6;
    }
  }

  .news_left_content {
    margin-top: 29px;

    .news_left_content_title {
      color: #333333;
      font-size: 18;
    }

    .news_left_content_date {
      font-size: 12px;
      color: #999999;
      line-height: 32px;
    }

    .news_left_content_brief {
      line-height: 24px;
      font-size: 14px;
      color: #666666;
    }
  }

  .know_more {
    color: #1b5ba0;
    position: absolute;
    right: 21px;
    bottom: 18px;
    cursor: pointer;
  }

  /* .news_right_content_cc div:hover {
    color: #ffffff !important;
  } */
</style>